import React, { useCallback, useMemo } from 'react';

import { TonnsFormatter } from '~/@components/Formatters';
import { LocalizableText } from '~/@components/LocalizableText';
import { ActionVariant, ITableCellAction, TableCellActions } from '~/@components/Table/TableCellActions';
import { canEditLineInline, IDeliveryLine, useDeliveryLineUpdateMutation } from '~/@store/deliveryLines';
import { LockEntityType, useDialogWithLock } from '~/@store/locks';
import { commonPrecisions } from '~/config/enum';

import { PopupNumberEdit } from '../../common/PopupEditFields';

type Props = {
    deliveryLine: IDeliveryLine;
};

export const DeliveryLineWeightCell = ({ deliveryLine }: Props) => {
    const [updateDeliveryLine] = useDeliveryLineUpdateMutation(deliveryLine);
    const disabled = !canEditLineInline(deliveryLine);

    const submit = useCallback((value: number) => updateDeliveryLine({ weight: value }), [updateDeliveryLine]);

    const dialogWithLock = useDialogWithLock(LockEntityType.ORDER, deliveryLine.orderNumber);

    const onEdit = useCallback(
        () =>
            dialogWithLock({
                render: closeDialog => (
                    <PopupNumberEdit
                        label={<LocalizableText code={'DeliveryLinesTable.weight'} />}
                        initialValue={deliveryLine.weight}
                        onSubmit={submit}
                        onClose={closeDialog}
                        precision={commonPrecisions.amount}
                    />
                ),
            }),
        [dialogWithLock, deliveryLine, submit]
    );

    const actions: Array<ITableCellAction> = useMemo(
        () => [
            {
                variant: ActionVariant.EDIT,
                onClick: onEdit,
                disabled,
            },
        ],
        [onEdit, disabled]
    );

    return (
        <TableCellActions actions={actions}>
            <TonnsFormatter>{deliveryLine.weight}</TonnsFormatter>
        </TableCellActions>
    );
};
